/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimImageRequest } from './CreateClaimImageRequest';
export type ClaimShippingRequest = {
    shopId: string;
    type: ClaimShippingRequest.type;
    shippingName: string;
    shippingNo?: string;
    images: Array<CreateClaimImageRequest>;
};
export namespace ClaimShippingRequest {
    export enum type {
        TRANSPORT = 'TRANSPORT',
        OTHER = 'OTHER',
    }
}

